import { FC, HTMLAttributes } from 'react'

export const PurpleArrowUpIcon: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#2F3343" />
    <path
      d="M19.7266 12.25L19.7266 27.25"
      stroke="#A35CFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.701 18.2998L19.725 12.2498L25.75 18.2998"
      stroke="#A35CFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
